import React, { useState } from 'react';

import { Divider, Text } from '@sede-enterprise/shell-ds-react-framework';

import styled from 'styled-components';

import Button from '../../../../../UI/Button';
import { Modal } from '../../../../../UI/Modal';
import {
  DELETE_SWING_CONTRACT_MAPPING,
  SWING_CONTRACT_MESSAGES,
} from '../../../../../constants/FieldNomsSwingContract';
import { deleteApi } from '../../../../../services/GenesisApi';
import { SwingContractMapping } from '../../../../../types/FieldNomsSwingContract.type';
import { ModalFooter } from '../style';
import { sendNotification } from '../../../../../UI/Notification';

const StyledContainer = styled.div`
  text-align: left;
`;

const StyledText = styled(Text)`
  color: #8f7630;
  font-weight: bold;
  margin-bottom: 10px;
`;

const StyledDetail = styled.div`
  margin-top: 10px;
`;

interface IDeleteMapping {
  open: boolean;
  onClose: () => void;
  selectedItem: SwingContractMapping | null;
  refreshData: () => void;
}

const ConfirmDeleteMapping: React.FC<IDeleteMapping> = ({
  selectedItem,
  open,
  onClose = () => {},
  refreshData = () => {},
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  const deleteMapping = () => {
    setLoading(true);
    deleteApi(`${DELETE_SWING_CONTRACT_MAPPING}?id=${selectedItem?.id}`, {})
      .then(() => {
        sendNotification({
          type: 'success',
          message: 'Mapping Deleted Successfully!',
        });
        onClose();
        refreshData();
      })
      .catch(() => {
        sendNotification({
          type: 'error',
          message: SWING_CONTRACT_MESSAGES.SERVER_ERROR,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const renderFooter = () => (
    <ModalFooter>
      <Button onClick={deleteMapping} loading={loading} disabled={loading}>
        Yes
      </Button>
      <Button variant='outlined' onClick={onClose}>
        Cancel
      </Button>
    </ModalFooter>
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      title='Delete Mapping'
      isDraggable
      maskClosable={false}
      footer={renderFooter()}
      width='40%'
    >
      {selectedItem && (
        <StyledContainer>
          <StyledText>
            Do you really want to delete this mapping? We recommend not to
            delete it if actual nomination records are linked to it.
          </StyledText>
          <Divider />
          <StyledDetail>
            <b>Deal ID:</b> {selectedItem?.deal_DealLegId}
          </StyledDetail>
        </StyledContainer>
      )}
    </Modal>
  );
};

export default ConfirmDeleteMapping;
